import { Component } from '@angular/core';
import { LanguageSelector } from '../../i18n';

@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  imports: [LanguageSelector],
  styleUrls: ['./home.scss'],
})
export class Home {
  static route = '';

  constructor() {}
}
